import React, { cloneElement } from "react";
import {
  Button,
  Datagrid,
  Filter,
  ResourceContextProvider,
  RowClickFunction,
  sanitizeListRestProps,
  SearchInput,
  ShowProps,
  TextField,
  TopToolbar,
  useListContext,
} from "react-admin";
import IconPlus from "@material-ui/icons/Add";
import { GetParam } from "utils/tools";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import CustomDateField from "components/CustomDateField";
import { ETypeHoliday } from "pages/holidays/const";
import { PaddingDenseStyled2List } from "../../components/ListWrapper";

const ThisFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const ListActions = (props: any) => {
  const { className, exporter, filters, maxResults, history, ...rest } = props;
  const { resource, displayedFilters, filterValues, showFilter } =
    useListContext();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}

      {filterValues.Type === ETypeHoliday.School && (
        <Button
          onClick={() =>
            history.push(
              `/holidays/create?source=${JSON.stringify({
                schoolId: Number(props.filterValues?.SchoolId),
                academicYearId: Number(props.filterValues?.AcademicYearId),
                type: ETypeHoliday.School,
              })}&schoolId=${Number(
                props.filterValues?.SchoolId
              )}&academicYearId=${props.filterValues?.AcademicYearId}`
            )
          }
          label="Create School Holiday"
        >
          <IconPlus />
        </Button>
      )}

      {filterValues.Type === ETypeHoliday.Public && (
        <Button
          onClick={() =>
            history.push(
              `/holidays/create?source=${JSON.stringify({
                schoolId: Number(props.filterValues?.SchoolId),
                academicYearId: Number(props.filterValues?.AcademicYearId),
                type: ETypeHoliday.Public,
              })}&schoolId=${Number(
                props.filterValues?.SchoolId
              )}&academicYearId=${props.filterValues?.AcademicYearId}`
            )
          }
          label="Create Public Holiday"
        >
          <IconPlus />
        </Button>
      )}
    </TopToolbar>
  );
};

const Holiday = (props: ShowProps) => {
  const param = GetParam();

  const rowClick: RowClickFunction = (id, basePath, record) =>
    `/holidays/${id}?schoolId=${param.get("schoolId")}&academicYearId=${
      props.id
    }`;

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">School Holidays</Typography>
      </Grid>
      <Grid item xs={12}>
        <ResourceContextProvider value="holidays">
          <PaddingDenseStyled2List
            {...props}
            exporter={false}
            hasCreate={false}
            filters={<ThisFilter />}
            filterDefaultValues={{
              SchoolId: Number(param.get("schoolId")),
              AcademicYearId: Number(props.id),
              Type: ETypeHoliday.School,
            }}
            bulkActionButtons={false}
            title=" "
            actions={<ListActions history={props.history} />}
          >
            <Datagrid rowClick={rowClick}>
              <TextField source="name" label="Holiday" />
              <CustomDateField source="date" />
            </Datagrid>
          </PaddingDenseStyled2List>
        </ResourceContextProvider>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h6">Public Holidays</Typography>
      </Grid>
      <Grid item xs={12}>
        <ResourceContextProvider value="holidays">
          <PaddingDenseStyled2List
            {...props}
            exporter={false}
            hasCreate={false}
            filters={<ThisFilter />}
            filterDefaultValues={{
              SchoolId: Number(param.get("schoolId")),
              AcademicYearId: Number(props.id),
              Type: ETypeHoliday.Public,
            }}
            bulkActionButtons={false}
            title=" "
            actions={<ListActions history={props.history} />}
          >
            <Datagrid rowClick={rowClick}>
              <TextField source="name" label="Holiday" />
              <CustomDateField source="date" />
            </Datagrid>
          </PaddingDenseStyled2List>
        </ResourceContextProvider>
      </Grid>
    </SanitizedGrid>
  );
};

export default Holiday;
